import { pointInsideBoundingBox, pointInEllipse } from "./intersection.js";

const intersection = {
  pointInsideBoundingBox,
  pointInEllipse
};

export default intersection;
